import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isMulti", "open", "showDropZone", "uploadButtonAriaDescribedby", "uploadButtonSize", "uploadButtonTitle", "uploadButtonVariant", "uploadIconTitle"];
import React, { forwardRef, memo } from 'react';
import { ButtonSize, ButtonVariant } from "../button";
import { IconUpload } from "../icons";
import { UploadButton } from "./helperComponents";
import { jsx as ___EmotionJSX } from "@emotion/core";
var FileUploadButton = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var isMulti = _ref.isMulti,
      open = _ref.open,
      showDropZone = _ref.showDropZone,
      uploadButtonAriaDescribedby = _ref.uploadButtonAriaDescribedby,
      uploadButtonSize = _ref.uploadButtonSize,
      uploadButtonTitle = _ref.uploadButtonTitle,
      uploadButtonVariant = _ref.uploadButtonVariant,
      uploadIconTitle = _ref.uploadIconTitle,
      forwardedProps = _objectWithoutProperties(_ref, _excluded);

  var shouldShowDropZone = showDropZone || isMulti;
  return ___EmotionJSX(UploadButton, _extends({}, forwardedProps, {
    "aria-describedby": uploadButtonAriaDescribedby,
    icon: ___EmotionJSX(IconUpload, {
      "aria-hidden": uploadButtonTitle.length > 0,
      title: uploadIconTitle
    }),
    isInDropZone: shouldShowDropZone,
    onClick: shouldShowDropZone ? undefined : open,
    ref: ref,
    shouldUseResponsiveContent: false,
    size: uploadButtonSize || (shouldShowDropZone ? ButtonSize.Small : ButtonSize.Default),
    variant: uploadButtonVariant || (shouldShowDropZone ? ButtonVariant.Tertiary : ButtonVariant.Primary)
  }), uploadButtonTitle);
}));
FileUploadButton.displayName = 'FileUploadButton';
export default FileUploadButton;